import React from 'react';
import { classNames } from '../util/classNames';
import { SnapIcon } from './SnapIcon';

type Props = {
  variant?:
    | 'default'
    | 'gray'
    | 'red'
    | 'yellow'
    | 'green'
    | 'purple'
    | 'white';
  size?: 'tiny' | 'small' | 'large';
  label: string;
  icon?: 'indicator' | 'remove' | 'leading';
  disabled?: boolean;
  className?: string;
};

type VariantType = Record<string, React.HTMLProps<HTMLElement>['className']>;

const variantStyles: VariantType = {
  default: 'border-[#60A5FA] bg-blue-100 text-blue-700',
  gray: 'border-gray-500 bg-gray-100 text-gray-700',
  red: 'border-[#F87171] bg-red-100 text-red-700',
  yellow: 'border-[#FBBF24] bg-yellow-100 text-yellow-700',
  green: 'border-[#34D399] bg-green-100 text-green-700',
  purple: 'border-[#C084FC] bg-purple-100 text-purple-700',
  white: 'border-[#94A3B8] bg-white-100 text-white-700',
};

const sizeStyles: VariantType = {
  tiny: 'text-[10px] leading-4 font-semibold',
  large: 'text-sm font-medium',
  small: 'text-xs font-medium',
};

export const SnapBadge = (props: Props) => {
  const {
    variant = 'default',
    size = 'small',
    icon,
    label,
    disabled = false,
  } = props;

  return (
    <div
      className={classNames(
        'inline-block border shadow-sm rounded-[5px] py-0.5 px-2',
        variantStyles[variant],
        sizeStyles[size],
        disabled ? 'opacity-50' : '',
        props.className,
      )}
    >
      {icon === 'indicator' || icon === 'leading' ? (
        <SnapIcon
          icon={icon === 'indicator' ? 'dot-solid' : 'arrow-up'}
          size='xs'
        />
      ) : null}
      {label}
      {icon === 'remove' ? <SnapIcon icon='x-solid' size='xs' /> : null}
    </div>
  );
};
